import PersonalGoalStage from './PersonalGoalStage';
import ScoreType from '../enums/ScoreType';

export default class Organization {
  constructor(data) {
    this.id = data?.id;
    this.activeEvaluationTermId = data?.activeEvaluationTermId;
    this.name = data?.name;
    this.scoreType = data?.scoreType ? ScoreType.of(data.scoreType) : null;
    this.evaluationStages = data?.evaluationStages ? Number(data.evaluationStages) : null;
    this.rankingEnabled = data?.rankingEnabled ? Boolean(data.rankingEnabled) : false;
    this.kpiEnabled = data?.kpiEnabled ? Boolean(data.kpiEnabled) : false;
    this.prevEvaluationDisplayed = data?.prevEvaluationDisplayed ? Boolean(data.prevEvaluationDisplayed) : false;
    this.personalGoalEnabled = data?.personalGoalEnabled ? Boolean(data.personalGoalEnabled) : false;
    this.personalGoalTitle = data?.personalGoalTitle;
    this.salaryCalculationEnabled = data?.salaryCalculationEnabled ? Boolean(data.salaryCalculationEnabled) : false;
    this.salaryDisplayEnabled = data?.salaryDisplayEnabled ? Boolean(data.salaryDisplayEnabled) : false;
    this.bonusDisplayEnabled = data?.bonusDisplayEnabled ? Boolean(data.bonusDisplayEnabled) : false;
    this.interviewRecordEnabled = data?.interviewRecordEnabled ? Boolean(data.interviewRecordEnabled) : false;
    this.logoPath = data?.logoPath;
    this.logo = data?.logo;

    this.personalGoalStages = data?.personalGoalStages ? data?.personalGoalStages.map(p => new PersonalGoalStage(p)) : [];
  }
}
